module.exports = __webpack_public_path__ + "img/introducer-hover.e5f38d27.jpg";